import talentsData from "../data/talents.json"
import skillsData from '../data/skills.json'
import characteristics from "../data/characteristics.json"
import { getEffective } from "./applyHomebrew"
import { stepRange, rangeIndex } from "./RangeStep"
import { shiftGranted } from "./QualityGrants"
const toNum = (v) => parseInt(v) || 0
const modCount = (mod) => parseInt(mod.Count) || 1

const modStatChange = (item, mod, remove) => {

    const talents = getEffective('talents', talentsData);
    const skills = getEffective('skills', skillsData);

    let moddedItem = JSON.parse(JSON.stringify(item))
    let statChange = false

    const baseModList = () => moddedItem.BaseMods ? (Array.isArray(moddedItem.BaseMods) ? moddedItem.BaseMods : [moddedItem.BaseMods]) : []
    const setField = (field, value) => {
        const preKey = "PreSet" + field
        const depthKey = "SetDepth" + field
        if (remove) {
            if (moddedItem[preKey] === undefined) return false
            if (moddedItem[depthKey] > 1) {
                moddedItem[depthKey] -= 1
                if (moddedItem[depthKey] === 1) delete moddedItem[depthKey]
                return true
            }
            moddedItem[field] = moddedItem[preKey] === null ? undefined : moddedItem[preKey]
            delete moddedItem[preKey]
            return true
        }
        if (moddedItem[preKey] === undefined) { moddedItem[preKey] = moddedItem[field] ?? null }
        else { moddedItem[depthKey] = (moddedItem[depthKey] || 1) + 1 }
        moddedItem[field] = value
        return true
    }
    const clampedShift = (field, delta, min, skipMissing) => {
        const debt = { ...(moddedItem.ClampDebt || {}) }
        if (skipMissing && (moddedItem[field] === undefined || moddedItem[field] === "") && !debt[field]) return
        let value = toNum(moddedItem[field])
        min = Math.min(min, value)
        if (delta > 0 && debt[field]) {
            const paid = Math.min(debt[field], delta)
            debt[field] -= paid
            delta -= paid
        }
        value += delta
        if (value < min) {
            debt[field] = (debt[field] || 0) + (min - value)
            value = min
        }
        Object.keys(debt).forEach(k => { if (!debt[k]) delete debt[k] })
        if (Object.keys(debt).length) { moddedItem.ClampDebt = debt } else { delete moddedItem.ClampDebt }
        moddedItem[field] = value
    }
    const trackDamage = (delta) => {
        const total = toNum(moddedItem.DamageDelta) + delta
        if (total) { moddedItem.DamageDelta = total } else { delete moddedItem.DamageDelta }
    }
    const clearDamageDebt = () => {
        if (!moddedItem.ClampDebt?.Damage) return
        const debt = { ...moddedItem.ClampDebt }
        delete debt.Damage
        if (Object.keys(debt).length) { moddedItem.ClampDebt = debt } else { delete moddedItem.ClampDebt }
    }
    const setDamage = (value) => {
        const delta = toNum(moddedItem.DamageDelta)
        if (remove) {
            if (moddedItem.PreSetDamage === undefined) { moddedItem.Damage = "0"; return }
            if (moddedItem.SetDepthDamage > 1) { setField("Damage", value); return }
            const base = moddedItem.PreSetDamage
            delete moddedItem.PreSetDamage
            clearDamageDebt()
            if (base === null) { moddedItem.Damage = undefined; return }
            moddedItem.Damage = toNum(base)
        } else {
            if (moddedItem.PreSetDamage === undefined) {
                moddedItem.PreSetDamage = moddedItem.Damage === undefined || moddedItem.Damage === ""
                    ? null
                    : toNum(moddedItem.Damage) - toNum(moddedItem.ClampDebt?.Damage) - delta
            } else {
                moddedItem.SetDepthDamage = (moddedItem.SetDepthDamage || 1) + 1
            }
            clearDamageDebt()
            moddedItem.Damage = toNum(value)
        }
        if (delta) { clampedShift("Damage", delta, 1) }
    }
    const shiftQuality = (key, delta) => {
        const debtKey = "Qual" + key
        const debt = { ...(moddedItem.ClampDebt || {}) }
        const quals = [...(moddedItem.Qualities || [])].map(q => ({ ...q }))
        const i = quals.findIndex(q => q.Key === key)
        if (i !== -1 && quals[i].Grants) {
            quals[i] = shiftGranted({ ...quals[i], Grants: [...quals[i].Grants] }, delta)
            moddedItem.Qualities = quals
            return
        }
        let count = i === -1 ? 0 : toNum(quals[i].Count)
        if (delta > 0 && debt[debtKey]) {
            const paid = Math.min(debt[debtKey], delta)
            debt[debtKey] -= paid
            delta -= paid
        }
        count += delta
        if (count < 0) {
            debt[debtKey] = (debt[debtKey] || 0) - count
            count = 0
        }
        if (count === 0 && i !== -1) { quals.splice(i, 1) }
        else if (count > 0 && i === -1) { quals.push({ Key: key, Count: String(count) }) }
        else if (count > 0) { quals[i].Count = String(count) }
        Object.keys(debt).forEach(k => { if (!debt[k]) delete debt[k] })
        if (Object.keys(debt).length) { moddedItem.ClampDebt = debt } else { delete moddedItem.ClampDebt }
        moddedItem.Qualities = quals
    }

    const rangeShift = (delta) => {
        const index = rangeIndex(moddedItem.Range)
        if (index === -1) return
        const virtual = index + toNum(moddedItem.RangeOverflow) + delta
        moddedItem.Range = stepRange(moddedItem.Range, virtual - index)
        const overflow = virtual - rangeIndex(moddedItem.Range)
        if (overflow) { moddedItem.RangeOverflow = overflow } else { delete moddedItem.RangeOverflow }
    }

    if (talents.find(t => t.Key === mod.Key)) {
        const desc = "Innate Talent: " + talents.find(t => t.Key === mod.Key).Name
        let newMods = baseModList()
        for (let n = 0; n < modCount(mod); n++) {
            if (remove) {
                const i = newMods.findIndex(m => m && m.MiscDesc === desc)
                if (i !== -1) { newMods.splice(i, 1) }
            } else {
                newMods.push({ MiscDesc: desc })
            }
        }
        moddedItem.BaseMods = newMods
        statChange = true
    }

    if (skills.find(s => s.Key === mod.Key) || characteristics.find(c => c.Key === mod.Key)) {
        let newMods = baseModList()
        if (remove) {
            let left = modCount(mod)
            while (left > 0) {
                const i = newMods.findIndex(m => m && m.Key === mod.Key)
                if (i === -1) break
                const have = modCount(newMods[i])
                if (have > left) {
                    newMods[i] = { ...newMods[i], Count: String(have - left) }
                    left = 0
                } else {
                    newMods.splice(i, 1)
                    left -= have
                }
            }
        } else {
            newMods.push(mod)
        }
        moddedItem.BaseMods = newMods
        statChange = true
    }

    if (mod.Key === "SUPERIOR" && moddedItem.SkillKey === undefined) {
        if (moddedItem.Categories === undefined) {
            moddedItem.Soak = remove ? Math.max(toNum(moddedItem.Soak) - modCount(mod), 0) : toNum(moddedItem.Soak) + modCount(mod)
        }
        statChange = true
    }
    else if (mod.Key === "DAMADD" || mod.Key === "DAMADDCRYS" || mod.Key === "SUPERIOR") {
        const field = moddedItem.Damage !== undefined && moddedItem.Damage !== "" ? "Damage" : "DamageAdd"
        if (field === "Damage") {
            const floor = toNum(moddedItem.Damage) - toNum(moddedItem.DamageDelta) >= 1 ? 1 : 0
            trackDamage(remove ? -modCount(mod) : modCount(mod))
            clampedShift("Damage", remove ? -modCount(mod) : modCount(mod), floor)
        } else {
            moddedItem[field] = toNum(moddedItem[field]) + (remove ? -modCount(mod) : modCount(mod))
        }
        statChange = true
    }
    if (mod.Key === "DAMSUB" || mod.Key === "DAMSUBCRYS") {
        if (moddedItem.Damage !== undefined) {
            if (moddedItem.Damage !== "" || moddedItem.ClampDebt?.Damage) { trackDamage(remove ? modCount(mod) : -modCount(mod)) }
            clampedShift("Damage", remove ? modCount(mod) : -modCount(mod), 1, true)
        } else {
            moddedItem.DamageAdd = toNum(moddedItem.DamageAdd) + (remove ? modCount(mod) : -modCount(mod))
        }
        statChange = true
    }
    if (mod.Key === "DAMSET") {
        setDamage(mod.Count)
        statChange = true
    }
    if (mod.Key === "CRITSUB") {
        clampedShift("Crit", remove ? modCount(mod) : -modCount(mod), 1, true)
        statChange = true
    }
    if (mod.Key === "CRITSET") {
        if (!setField("Crit", mod.Count)) { moddedItem.Crit = undefined }
        statChange = true
    }
    if (mod.Key?.startsWith("SUBQUAL")) {
        shiftQuality(mod.Key.slice(7), remove ? modCount(mod) : -modCount(mod))
        statChange = true
    }
    if (mod.Key === "ENCSUB") {
        clampedShift("Encumbrance", remove ? modCount(mod) : -modCount(mod), 0)
        statChange = true
    }
    if (mod.Key === "ENCSUB2") {
        clampedShift("Encumbrance", remove ? 2 * modCount(mod) : -2 * modCount(mod), 0)
        statChange = true
    }
    if (mod.Key === "ENCADD") {
        clampedShift("Encumbrance", remove ? -modCount(mod) : modCount(mod), 0)
        statChange = true
    }
    if (mod.Key === "HPADD") {
        if (remove) {
            moddedItem.HP -= (1 * (mod.Count || 1))
            if (moddedItem.HP === 0) { delete moddedItem.HP }
        }
        else {
            moddedItem.HP = parseInt(moddedItem.HP || 0) + (1 * (mod.Count || 1))
        }
        statChange = true
    }
    if (mod.Key === "HPSUB") {
        clampedShift("HP", remove ? modCount(mod) : -modCount(mod), 0)
        statChange = true
    }
    if (mod.Key === "RANGEADD") {
        rangeShift(remove ? -modCount(mod) : modCount(mod))
        statChange = true
    }
    if (mod.Key === "RANGESUB") {
        const minIndex = mod.MinRange ? rangeIndex(mod.MinRange) : -1
        if (minIndex === -1 || rangeIndex(moddedItem.Range) === -1) {
            rangeShift(remove ? modCount(mod) : -modCount(mod))
        } else {
            const debt = { ...(moddedItem.ClampDebt || {}) }
            const debtKey = "Range" + mod.MinRange
            if (remove) {
                const paid = Math.min(debt[debtKey] || 0, modCount(mod))
                debt[debtKey] = (debt[debtKey] || 0) - paid
                rangeShift(modCount(mod) - paid)
            } else {
                const current = rangeIndex(moddedItem.Range) + toNum(moddedItem.RangeOverflow)
                const allowed = Math.min(modCount(mod), Math.max(0, current - minIndex))
                debt[debtKey] = (debt[debtKey] || 0) + modCount(mod) - allowed
                rangeShift(-allowed)
            }
            Object.keys(debt).forEach(k => { if (!debt[k]) delete debt[k] })
            if (Object.keys(debt).length) { moddedItem.ClampDebt = debt } else { delete moddedItem.ClampDebt }
        }
        statChange = true
    }
    if (mod.Key === "RANGEREDMED") {
        if (remove) {
            setField("Range")
        }
        else if (rangeIndex(item.Range) !== -1) {
            setField("Range", stepRange(item.Range, Math.min(0, 2 - rangeIndex(item.Range))))
        }
        statChange = true
    }
    if (mod.Key === "SOAKADD") {
        if (remove) {
            moddedItem.Soak = Math.max(toNum(moddedItem.Soak) - modCount(mod), 0)
        }
        else {
            moddedItem.Soak = toNum(moddedItem.Soak) + modCount(mod)
        }
        statChange = true
    }
    if (mod.Key === "SOAKSET") {
        if (remove) {
            moddedItem.Soak = moddedItem.PreSetSoak ?? 0
            delete moddedItem.PreSetSoak
        }
        else {
            if (moddedItem.PreSetSoak === undefined) { moddedItem.PreSetSoak = toNum(moddedItem.Soak) }
            moddedItem.Soak = mod.Count
        }
        statChange = true
    }
    if (mod.Key === "DEFADD") {
        if (remove) {
            moddedItem.Defense = Math.max(toNum(moddedItem.Defense) - modCount(mod), 0)
        }
        else {
            moddedItem.Defense = toNum(moddedItem.Defense) + modCount(mod)
        }
        statChange = true
    }
    if (mod.Key === "DEFSET") {
        if (remove) {
            moddedItem.Defense = moddedItem.PreSetDefense ?? 0
            delete moddedItem.PreSetDefense
        }
        else {
            if (moddedItem.PreSetDefense === undefined) { moddedItem.PreSetDefense = toNum(moddedItem.Defense) }
            moddedItem.Defense = mod.Count
        }
        statChange = true
    }
    if (mod.Key === "MELEEDEFADD") {
        if (remove) {
            moddedItem.MeleeDefense = Math.max(toNum(moddedItem.MeleeDefense) - modCount(mod), 0)
        }
        else {
            moddedItem.MeleeDefense = toNum(moddedItem.MeleeDefense) + modCount(mod)
        }
        statChange = true
    }
    if (mod.Key === "RANGEDEFADD") {
        if (remove) {
            moddedItem.RangedDefense = Math.max(toNum(moddedItem.RangedDefense) - modCount(mod), 0)
        }
        else {
            moddedItem.RangedDefense = toNum(moddedItem.RangedDefense) + modCount(mod)
        }
        statChange = true
    }
    if (mod.Key === "USERANGLT") {
        if (!setField("SkillKey", "RANGLT")) { moddedItem.SkillKey = "RANGHVY" }
        statChange = true
    }
    if (mod.Key === "USERANGHVY") {
        if (!setField("SkillKey", "RANGHVY")) { moddedItem.SkillKey = "RANGLT" }
        statChange = true
    }
    if (mod.Key === "INFERIOR") {
        if (remove) {
            moddedItem.Damage += 1
        }
        else {
            moddedItem.Damage -= 1
        }
    }
    if (mod.Key === "SPEEDADD") {
        if (remove) {
            moddedItem.Speed = parseInt(moddedItem.Speed) - mod.Count
        }
        else {
            moddedItem.Speed ? moddedItem.Speed = parseInt(moddedItem.Speed) + parseInt(mod.Count) : moddedItem.Speed = parseInt(mod.Count)
        }
        statChange = true
    }
    if (mod.Key === "SSTRAINADD") {
        if (remove) {
            moddedItem.SystemStrain = parseInt(moddedItem.SystemStrain) - mod.Count
        }
        else {
            moddedItem.SystemStrain ? moddedItem.SystemStrain = parseInt(moddedItem.SystemStrain) + parseInt(mod.Count) : moddedItem.SystemStrain = parseInt(mod.Count)
        }
        statChange = true
    }
    if (mod.Key === "SSTRAINADDSIL") {
        if (remove) {
            moddedItem.SystemStrain -= (parseInt(mod.Count) * moddedItem.Silhouette)
        }
        else {
            moddedItem.SystemStrain ? moddedItem.SystemStrain = parseInt(moddedItem.SystemStrain) + (parseInt(mod.Count) * moddedItem.Silhouette) : moddedItem.SystemStrain = (parseInt(mod.Count) * moddedItem.Silhouette)
        }
        statChange = true
    }
    if (mod.Key === "SSTRAINSUB") {
        if (remove) {
            moddedItem.SystemStrain = parseInt(moddedItem.SystemStrain) + parseInt(mod.Count)
        }
        else {
            moddedItem.SystemStrain ? moddedItem.SystemStrain = parseInt(moddedItem.SystemStrain) - parseInt(mod.Count) : moddedItem.SystemStrain = -parseInt(mod.Count)
        }
        statChange = true
    }
    if (mod.Key === "HANDLINGADD") {
        if (remove) {
            moddedItem.Handling = parseInt(moddedItem.Handling) - parseInt(mod.Count)
        }
        else {
            moddedItem.Handling ? moddedItem.Handling = parseInt(moddedItem.Handling) + parseInt(mod.Count) : moddedItem.Handling = parseInt(mod.Count)
        }
        statChange = true
    }
    if (mod.Key === "HANDLINGSUB") {
        if (remove) {
            moddedItem.Handling = parseInt(moddedItem.Handling) + parseInt(mod.Count)
        }
        else {
            moddedItem.Handling ? moddedItem.Handling = parseInt(moddedItem.Handling) - parseInt(mod.Count) : moddedItem.Handling = -parseInt(mod.Count)
        }
        statChange = true
    }
    if (mod.Key === "ARMORADD") {
        if (remove) {
            moddedItem.Armor = parseInt(moddedItem.Armor) - mod.Count
        }
        else {
            moddedItem.Armor ? moddedItem.Armor = parseInt(moddedItem.Armor) + parseInt(mod.Count) : moddedItem.Armor = parseInt(mod.Count)
        }
        statChange = true
    }
    if (mod.Key === "ENCCADD") {
        if (remove) {
            moddedItem.EncumbranceCapacity = parseInt(moddedItem.EncumbranceCapacity) - mod.Count
        }
        else {
            moddedItem.EncumbranceCapacity ? moddedItem.EncumbranceCapacity = parseInt(moddedItem.EncumbranceCapacity) + parseInt(mod.Count) : moddedItem.EncumbranceCapacity = parseInt(mod.Count)
        }
        statChange = true
    }
    if (mod.Key === "ENCTADD3") {
        if (remove) {
            moddedItem.EncumbranceCapacity = parseInt(moddedItem.EncumbranceCapacity) - (mod.Count * 3)
        }
        else {
            moddedItem.EncumbranceCapacity ? moddedItem.EncumbranceCapacity = parseInt(moddedItem.EncumbranceCapacity) + parseInt(mod.Count * 3) : moddedItem.EncumbranceCapacity = parseInt(mod.Count * 3)
        }
        statChange = true
    }
    if (mod.Key === "ENCADDSIL") {
        if (remove) {
            moddedItem.EncumbranceCapacity -= (parseInt(mod.Count) * moddedItem.Silhouette)
        }
        else {
            moddedItem.EncumbranceCapacity ? moddedItem.EncumbranceCapacity = parseInt(moddedItem.EncumbranceCapacity) + (parseInt(mod.Count) * moddedItem.Silhouette) : moddedItem.EncumbranceCapacity = (parseInt(mod.Count) * moddedItem.Silhouette)
        }
        statChange = true
    }
    if (mod.Key === "PASSADDSIL") {
        if (remove) {
            moddedItem.Passengers -= (parseInt(mod.Count) * moddedItem.Silhouette)
        }
        else {
            moddedItem.Passengers ? moddedItem.Passengers = parseInt(moddedItem.Passengers) + (parseInt(mod.Count) * moddedItem.Silhouette) : moddedItem.Passengers = (parseInt(mod.Count) * moddedItem.Silhouette)
        }
        statChange = true
    }
    if (mod.Key === "PASSADD2") {
        moddedItem.Passengers = toNum(moddedItem.Passengers) + (remove ? -2 : 2) * modCount(mod)
        statChange = true
    }
    if (mod.Key === "HULLADD") {
        if (remove) {
            moddedItem.HullTrauma -= (parseInt(mod.Count))
        }
        else {
            moddedItem.HullTrauma ? moddedItem.HullTrauma = parseInt(moddedItem.HullTrauma) + (parseInt(mod.Count)) : moddedItem.HullTrauma = (parseInt(mod.Count))
        }
        statChange = true
    }
    if (mod.Key === "HULLADDSIL") {
        if (remove) {
            moddedItem.HullTrauma -= (parseInt(mod.Count) * moddedItem.Silhouette)
        }
        else {
            moddedItem.HullTrauma ? moddedItem.HullTrauma = parseInt(moddedItem.HullTrauma) + (parseInt(mod.Count) * moddedItem.Silhouette) : moddedItem.HullTrauma = (parseInt(mod.Count) * moddedItem.Silhouette)
        }
        statChange = true
    }
    if (mod.Key === "ADDDEFFORE") {
        if (remove) {
            moddedItem.DefFore -= mod.Count
        }
        else {
            moddedItem.DefFore ? moddedItem.DefFore = parseInt(moddedItem.DefFore) + parseInt(mod.Count) : moddedItem.DefFore = parseInt(mod.Count)
        }
        statChange = true
    }
    if (mod.Key === "ADDDEFPORT") {
        if (remove) {
            moddedItem.DefPort -= parseInt(mod.Count)
        }
        else {
            moddedItem.DefPort ? moddedItem.DefPort = parseInt(moddedItem.DefPort) + parseInt(mod.Count) : moddedItem.DefPort = parseInt(mod.Count)
        }
        statChange = true
    }
    if (mod.Key === "ADDDEFSTAR") {
        if (remove) {
            moddedItem.DefStar -= parseInt(mod.Count)
        }
        else {
            moddedItem.DefStar ? moddedItem.DefStar = parseInt(moddedItem.DefStar) + parseInt(mod.Count) : moddedItem.DefStar = parseInt(mod.Count)
        }
        statChange = true
    }
    if (mod.Key === "ADDDEFAFT") {
        if (remove) {
            moddedItem.DefAft -= parseInt(mod.Count)
        }
        else {
            moddedItem.DefAft ? moddedItem.DefAft = parseInt(moddedItem.DefAft) + parseInt(mod.Count) : moddedItem.DefAft = parseInt(mod.Count)
        }
        statChange = true
    }
    if (mod.Key?.startsWith("REMQUAL")) {
        const qualKey = mod.Key.slice(7)
        const preKey = "PreSetQual" + qualKey
        const depthKey = "SetDepthQual" + qualKey
        const quals = [...(moddedItem.Qualities || [])]
        if (remove && moddedItem[depthKey] > 1) {
            moddedItem[depthKey] -= 1
            if (moddedItem[depthKey] === 1) delete moddedItem[depthKey]
        }
        else if (remove) {
            const prior = moddedItem[preKey]
            delete moddedItem[preKey]
            if (prior !== null) { quals.push(prior === "" ? { Key: qualKey } : { Key: qualKey, Count: prior === undefined ? "1" : prior }) }
        }
        else {
            const existing = quals.find(q => q.Key === qualKey)
            if (moddedItem[preKey] === undefined) { moddedItem[preKey] = existing ? String(existing.Count ?? "") : null }
            else { moddedItem[depthKey] = (moddedItem[depthKey] || 1) + 1 }
        }
        moddedItem.Qualities = quals.filter(q => remove || q.Key !== qualKey)
        statChange = true
    }
    if (mod.Key === "SETARMOR") {
        if (!setField("Armor", parseInt(mod.Count))) { moddedItem.Armor -= 1 }
        statChange = true
    }
    if (mod.Key === "SETHAND") {
        if (!setField("Handling", parseInt(mod.Count))) { moddedItem.Handling -= 1 }
        statChange = true
    }
    if (mod.Key === "SETDEFAFT") {
        if (!setField("DefAft", parseInt(mod.Count))) { moddedItem.DefAft -= 1 }
        statChange = true
    }
    if (mod.Key === "ADDCRYSTNC") {
        statChange = true
    }

    return [moddedItem, statChange]
}

export default modStatChange